import * as React from 'react';
import { FC } from 'react';
import Router from 'src/navigation/router';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from './assets/breadcrumbs.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

/*interface TwoOrMoreArray<T> extends Array<T> {
    0: T
    1: T
}*/
// TwoOrMoreArray<{ name: string, path: string }>;
interface Props {
    items: { name: string; path: string }[];
    noGenerate?: boolean;
}

const Breadcrumbs: FC<Props> = ({ items, noGenerate }: Props) => {
    // @ts-ignore
    const current: { name: string; path: string } = items.pop();

    return (
        <div className={classNames(styles.breadcrumbWrap)}>
            {items.map((itRender: { name: string; path: string }, i: number) => (
                <h2 key={`${i}-bread`} className={classNames(styles.headerCrumb)}>
                    <Link key={`${i}-link`} to={noGenerate ? itRender.path : Router.generate(itRender.path)}>
                        {itRender.name}
                    </Link>
                    <FontAwesomeIcon icon={faChevronRight} />
                </h2>
            ))}
            <h2 className="pageHeadingTitle">{current.name}</h2>
        </div>
    );
};

export default Breadcrumbs;
